/**
 * @generated SignedSource<<9f274ed63bff36f7d0055a2234aa0fc6>>
 * @relayHash b7f1d13467dd6b4f836e1ee3bb110c45
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b7f1d13467dd6b4f836e1ee3bb110c45

import { ConcreteRequest } from 'relay-runtime';
export type De_forceDeleteProgressNoteInput = {
  id: string;
};
export type deForceDeleteProgressNoteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: De_forceDeleteProgressNoteInput;
};
export type deForceDeleteProgressNoteMutation$data = {
  readonly forceDeleteProgressNote: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly progressNote: {
      readonly id: string;
    } | null;
  };
};
export type deForceDeleteProgressNoteMutation = {
  response: deForceDeleteProgressNoteMutation$data;
  variables: deForceDeleteProgressNoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deForceDeleteProgressNoteMutation",
    "selections": [
      {
        "alias": "forceDeleteProgressNote",
        "args": (v2/*:: as any*/),
        "concreteType": "De_forceDeleteProgressNotePayload",
        "kind": "LinkedField",
        "name": "de_forceDeleteProgressNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "de_ProgressNote",
            "kind": "LinkedField",
            "name": "de_ProgressNote",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deForceDeleteProgressNoteMutation",
    "selections": [
      {
        "alias": "forceDeleteProgressNote",
        "args": (v2/*:: as any*/),
        "concreteType": "De_forceDeleteProgressNotePayload",
        "kind": "LinkedField",
        "name": "de_forceDeleteProgressNote",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "de_ProgressNote",
            "kind": "LinkedField",
            "name": "de_ProgressNote",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "b7f1d13467dd6b4f836e1ee3bb110c45",
    "metadata": {},
    "name": "deForceDeleteProgressNoteMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "bbd12d7caf05505af880e863cfa65fe4";

export default node;
